export const investmentDocConstants = {
  INVESTMENT_DOC_CREATE_LOADING: 'INVESTMENT_DOC_CREATE_LOADING',
  INVESTMENT_DOC_CREATE_SUCCESS: 'INVESTMENT_DOC_CREATE_SUCCESS',
  INVESTMENT_DOC_CREATE_FAILURE: 'INVESTMENT_DOC_CREATE_FAILURE',
  INVESTMENT_DOC_ERROR_RELOAD: 'INVESTMENT_DOC_ERROR_RELOAD',

  INVESTMENT_DOC_LIST_LOADING: 'INVESTMENT_DOC_LIST_LOADING',
  INVESTMENT_DOC_LIST_SUCCESS: 'INVESTMENT_DOC_LIST_SUCCESS',
  INVESTMENT_DOC_LIST_FAILURE: 'INVESTMENT_DOC_LIST_FAILURE',

  INVESTMENT_DOC_EDIT_LOADING: 'INVESTMENT_DOC_EDIT_LOADING',
  INVESTMENT_DOC_EDIT_SUCCESS: 'INVESTMENT_DOC_EDIT_SUCCESS',
  INVESTMENT_DOC_EDIT_FAILURE: 'INVESTMENT_DOC_EDIT_FAILURE',

  INVESTMENT_DOC_DELETE_LOADING: 'INVESTMENT_DOC_DELETE_LOADING',
  INVESTMENT_DOC_DELETE_SUCCESS: 'INVESTMENT_DOC_DELETE_SUCCESS',
  INVESTMENT_DOC_DELETE_FAILURE: 'INVESTMENT_DOC_DELETE_FAILURE'
};
